import { AbstractFWGlobalParams } from 'tag/ts/tag/ads/freewheel/abstract/AbstractFWGlobalParams';
import { AdSetupDefinition } from 'tag/ts/tag/model/type/ads/AdSetupDefinition';
export class FWGlobalParams extends AbstractFWGlobalParams {
    adParams;
    constructor(argument) {
        super({
            name: 'FWGlobalParams',
            ...argument
        });
        switch (argument?.adSetupInfo?.setup?.definition) {
            case AdSetupDefinition.IMA:
                this.adParams = this.createIMAParams();
                this?.logger?.log('AdSetupDefinition = IMA, createIMAParams', 'params:', this.adParams);
                break;
            case AdSetupDefinition.DAI_SDK:
            case AdSetupDefinition.DAI_SSB:
                this.adParams = this.createDAIParams();
                this?.logger?.log('AdSetupDefinition = DAI_SDK | DAI_SSB, createDAIParams', 'params:', this.adParams);
                break;
            case AdSetupDefinition.DAI_API:
                this.adParams = this.createDAIAPIParams();
                this?.logger?.log('AdSetupDefinition = DAI_API, createDAIAPIParams', 'params:', this.adParams);
                break;
            case AdSetupDefinition.LINEAR_AD_TRACKING:
                this.adParams = this.createLinearParams();
                break;
        }
    }
    createIMAParams() {
        return {
            asnw: this.fwConstants.assetNetworkId,
            caid: this.apiMetadata?.contentId,
            csid: this.siteSessionData?.csid?.toLowerCase() || this.createSiteSectionId(),
            flag: this.fwConstants.capabilitiesFlag,
            metr: this.fwConstants.defaultCapabilities,
            nw: this.fwConstants.networkId,
            prof: this.fwConstants.playerProfile,
            pvrn: this.fwConstants.pageView,
            resp: this.fwConstants.response,
            ssnw: this.fwConstants.siteSectionNetworkId,
            vprn: this.fwConstants.videoPlayer
        };
    }
    createDAIParams() {
        return {
            imafw_csid: this.siteSessionData?.csid?.toLowerCase() || this.createSiteSectionId()
        };
    }
    createLinearParams() {
        return {
            asnw: this.fwConstants.assetNetworkId,
            caid: 'Superbowl_58_Linear_Stream_Game_Day',
            csid: this.createSiteSectionId(),
            flag: '+amcb+emcr+dtrd+sltp+slcb+exvt+fbad+sync+nucr+aeti',
            metr: this.fwConstants.defaultCapabilities,
            nw: this.fwConstants.assetNetworkId,
            mode: 'LIVE',
            prof: `${this.fwConstants.assetNetworkId}:superbowl`,
            pvrn: this.fwConstants.randomTag,
            resp: this.fwConstants.response,
            ssnw: this.fwConstants.assetNetworkId,
            vdty: 'VARIABLE',
            vrdu: this.fwConstants.durTag,
            vprn: this.fwConstants.randomTag
        };
    }
    createDAIAPIParams() {
        return {
            imafw_csid: 'streaming_paramountplus_ctv_unknown_vod',
            imafw_cpPre: !!this.isLive() ? undefined : '0',
            imafw_cpSession: !!this.isLive() ? undefined : '0',
            imafw_description_url: 'https%3A%2F%2Fwww.paramountplus.com%2F'
        };
    }
    get adParameters() {
        return this.adParams;
    }
}
